"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.adjustArrowAlign = adjustArrowAlign;
exports.adjustArrowReachLimit = adjustArrowReachLimit;
exports.arrowDomAlign = arrowDomAlign;
exports.getViewport = getViewport;
exports.isCornerNeedAlign = isCornerNeedAlign;
exports.isReachLimit = isReachLimit;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _domAlign = _interopRequireDefault(require("dom-align"));
var _dom = _interopRequireDefault(require("./dom"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } /* istanbul ignore file */
function getWH(element, props) {
  return _dom.default.getWH(element, props);
}
/**
 * 是否是左右方向
 * @param {*} points
 */
function isLrDirection(points) {
  var sourceDir = points[0];
  var targetDir = points[1];
  var LR_REG = /^[ctb][rl]$/; // 左右
  // 两者第一个字符都是一样的
  return LR_REG.test(sourceDir) && LR_REG.test(targetDir) && sourceDir.charAt(0) === targetDir.charAt(0);
}
/**
 * 是否是上下方向
 * @param {*} points
 */
function isTbDirection(points) {
  var sourceDir = points[0];
  var targetDir = points[1];
  var TB_REG = /^[bt][clr]$/; // 上下
  // 两者第二个字符都是一样的
  return TB_REG.test(sourceDir) && TB_REG.test(targetDir) && sourceDir.charAt(1) === targetDir.charAt(1);
}
/**
 * 获取第一个overflow不为visible的父元素
 * @param {*} element
 */
function getFirstNotVisiableElem(element) {
  if (element.parentNode && element.parentNode.nodeType === 9) {
    return document.body;
  }
  if (window.getComputedStyle(element).overflow === 'visible') {
    if (element.parentNode) {
      return getFirstNotVisiableElem(element.parentNode);
    }
    return element;
  }
  return element;
}
/**
 * 获取视口viewport的位置及关键属性
 * @param {*} container 视口的dom节点
 * @returns
 */
function getViewport(container) {
  // alignContainer的大小信息
  var viewport = {};
  if (container === window) {
    // 视口
    viewport = {
      width: getWH(window, 'width'),
      height: getWH(container, 'height'),
      left: 0,
      top: 0,
      borderLeft: 0,
      borderRight: 0,
      borderTop: 0,
      borderBottom: 0,
      scrollBarWidthRight: 0,
      scrollBarWidthBottom: 0
    };
  } else {
    /*
     * 父元素
     * domalign定位时会自动向上找第一个为overflow hidden/auto的元素作为定位边界
     * 所以需要找出真实定位的父元素
     */
    var domAlignContainer = getFirstNotVisiableElem(container);
    var style = getComputedStyle(domAlignContainer);
    var pos = _dom.default.getOffset(domAlignContainer);
    viewport = {
      width: getWH(domAlignContainer, 'width'),
      height: getWH(domAlignContainer, 'height'),
      left: pos.left,
      top: pos.top,
      borderLeft: parseFloat(style.borderLeftWidth),
      borderRight: parseFloat(style.borderRightWidth),
      borderTop: parseFloat(style.borderTopWidth),
      borderBottom: parseFloat(style.borderBottomWidth),
      scrollBarWidthRight: domAlignContainer.offsetWidth - domAlignContainer.clientWidth - parseFloat(style.borderLeftWidth) - parseFloat(style.borderRightWidth),
      scrollBarWidthBottom: domAlignContainer.offsetHeight - domAlignContainer.clientHeight - parseFloat(style.borderTopWidth) - parseFloat(style.borderBottomWidth)
    };
  }
  return viewport;
}
// const HALF_ARROW = 3; // 初始三角的宽/高
var HALF_SHOW_ARROW = 5; // 半个实际展示三角的宽/高
var ARROW_TARGET_GAP = 7; // 三角中心与target的间隔
/*
 * const ARROW_TARGET_GAP = 2.75; // 三角中心与target的间隔
 * const ARROW_TARGET_GAP = 3; // 三角中心与target的间隔
 */
var BORDER_RADIUS = 4; // 圆角
/**
 * 判断三角是否临界，不临界返回0，临界返回建议的offset值
 * @param {*} elementRect arrow的数据
 * @param {*} viewport 视口的数据
 * @param {string} position 临界方位（视口）：'top' || 'bottom' || 'left' || 'right',
 * 判断依据：target的中点与视口对应边界的距离是否足够容纳半个三角加tooltip圆角（即3+4px）
 */
function arrowLimitOffset(viewport, targetProper, position) {
  var offset = 0; //
  // let arrowOffset = 0; //
  var tagetCenterLimitDistance = 0; // 参照物中心点与视口的距离
  var isOutOfLimit = true; // target节点是否已超出对应边界
  /**
   * 22.12.8，新增补丁：先判断target是否已超出对应边界，超出边界则三角无需适配边界，直接定位到target中间即可
   * （参考tt：https://tt.sankuai.com/ticket/detail?id=72686808，
   *  复现：1. 给项目设置最小宽度（如税务为1200），缩小页面宽度使html宽度小于前面设定的值，使页面可以左右滚动，最右侧区域不处于html内但可视，打开Drawer发现依然可以左右滚动
   *       2. 在Drawer内加个tooltip，使其target可视但处于html右侧，弹出tooltip即可发现三角位置在html内，但tooltip主体在html外
   */
  switch (position) {
    case 'top':
      tagetCenterLimitDistance = targetProper.top + targetProper.height / 2 - (viewport.top + viewport.borderTop);
      isOutOfLimit = targetProper.top + targetProper.height < viewport.top;
      // 当target中心与视口边界距离足够容纳小三角+圆角时，或target不在对应边界内，无需重定位，直接返回
      if (tagetCenterLimitDistance > HALF_SHOW_ARROW + BORDER_RADIUS || isOutOfLimit) return 0;
      offset = viewport.top + viewport.borderTop - (targetProper.top + targetProper.height / 2) + (BORDER_RADIUS + HALF_SHOW_ARROW);
      break;
    case 'bottom':
      tagetCenterLimitDistance = viewport.top + viewport.height - (viewport.borderBottom + viewport.scrollBarWidthBottom) - (targetProper.top + targetProper.height / 2);
      isOutOfLimit = targetProper.top > viewport.top + viewport.height;
      if (isOutOfLimit || tagetCenterLimitDistance > HALF_SHOW_ARROW + BORDER_RADIUS) return 0;
      offset = viewport.top + viewport.height - (viewport.borderBottom + viewport.scrollBarWidthBottom) - (targetProper.top + targetProper.height / 2) - (BORDER_RADIUS + HALF_SHOW_ARROW);
      break;
    case 'left':
      tagetCenterLimitDistance = targetProper.left + targetProper.width / 2 - (viewport.left + viewport.borderLeft);
      isOutOfLimit = targetProper.left + targetProper.width < viewport.left;
      if (isOutOfLimit || tagetCenterLimitDistance > BORDER_RADIUS + HALF_SHOW_ARROW) return 0;
      offset = viewport.left + viewport.borderLeft - (targetProper.left + targetProper.width / 2) + (BORDER_RADIUS + HALF_SHOW_ARROW);
      break;
    case 'right':
      tagetCenterLimitDistance = viewport.left + viewport.width - (viewport.borderRight + viewport.scrollBarWidthRight) - (targetProper.left + targetProper.width / 2);
      isOutOfLimit = targetProper.left > viewport.left + viewport.width;
      if (isOutOfLimit || tagetCenterLimitDistance > BORDER_RADIUS + HALF_SHOW_ARROW) return 0;
      offset = viewport.left + viewport.width - (viewport.borderRight + viewport.scrollBarWidthRight) - (targetProper.left + targetProper.width / 2) - (BORDER_RADIUS + HALF_SHOW_ARROW);
      break;
    default:
      break;
  }
  return offset;
}
/**
 * 使定位适配临界状态
 * @param {*} windowViewport window参数
 * @param {*} viewport 视口参数
 * @param {*} param2 targetNode: 附着的目标节点；direction：三角所在方位；arrowAlign：三角的初始定位参数
 * @returns {Object} 适配临界状态后的align信息的offset
 */
function adjustArrowReachLimit(windowViewport, viewport, options) {
  /*
   * 计算target的属性
   * const targetStyle = getComputedStyle(targetNode);
   */
  var targetPos = _dom.default.getOffset(options.targetNode);
  var targetProper = {
    width: getWH(options.targetNode, 'width'),
    height: getWH(options.targetNode, 'height'),
    left: targetPos.left,
    top: targetPos.top
  };
  var newOffset = [];
  var suggestOffset = 0;
  /*
   * 在arrow达到边界时，判断是否需要重新定位
   * 左右位置时，
   */
  if (options.direction === 'l' || options.direction === 'r') {
    var offsetX = options.direction === 'l' ? ARROW_TARGET_GAP : -ARROW_TARGET_GAP;
    // 到达 上 边界
    suggestOffset = arrowLimitOffset(windowViewport, targetProper, 'top') || arrowLimitOffset(viewport, targetProper, 'top');
    if (suggestOffset) {
      newOffset = [offsetX, suggestOffset];
      return newOffset;
    }
    // 到达下 边界
    suggestOffset = Math.min(arrowLimitOffset(windowViewport, targetProper, 'bottom'), arrowLimitOffset(viewport, targetProper, 'bottom'));
    if (suggestOffset) {
      newOffset = [offsetX, suggestOffset];
      return newOffset;
    }
    // 上下都没临界
    return [offsetX, 0];
  }
  // 上下位置时，
  if (options.direction === 't' || options.direction === 'b') {
    var offsetY = options.direction === 't' ? ARROW_TARGET_GAP : -ARROW_TARGET_GAP;
    // 到达左边界
    suggestOffset = arrowLimitOffset(windowViewport, targetProper, 'left') || arrowLimitOffset(viewport, targetProper, 'left');
    if (suggestOffset) {
      newOffset = [suggestOffset, offsetY];
      return newOffset;
    }
    // 到达右边界
    suggestOffset = arrowLimitOffset(windowViewport, targetProper, 'right') || arrowLimitOffset(viewport, targetProper, 'right');
    if (suggestOffset) {
      newOffset = [suggestOffset, offsetY];
      return newOffset;
    }
    // 左右都没临界
    return [0, offsetY];
  }
  return [0, 0];
}
/**
 * 判断element是否在containr的边界
 * 左右 上下边界
 * @param dom
 * @param container
 * @returns {boolean}
 */
function isReachLimit(element, viewport, options) {
  // popLayer的大小信息
  var elementPos = _dom.default.getOffset(element);
  var elementRect = {
    width: getWH(element, 'width'),
    height: getWH(element, 'height'),
    // left top
    left: elementPos.left,
    top: elementPos.top
  };
  /*
   * 在popLayer达到边界时，判断是否需要重新定位��视口的边界应将其border和滚动条宽度算上
   * 左右位置时，
   */
  if (isLrDirection(options.popNodeAlign.points)) {
    // 到达 上下 边界
    if (elementRect.top === viewport.top + viewport.borderTop || elementRect.top + elementRect.height + viewport.borderBottom === viewport.top + viewport.height - viewport.scrollBarWidthBottom) {
      return true;
    }
    return false;
  }
  // 上下位置时，
  if (isTbDirection(options.popNodeAlign.points)) {
    // 到达 左右 边界
    if (elementRect.left === viewport.left + viewport.borderLeft || elementRect.left + elementRect.width + viewport.borderRight === viewport.left + viewport.width - viewport.scrollBarWidthRight) {
      return true;
    }
    /*
     * target宽度过小
     * 目标元素实际内容宽度小于32
     * if (getWH(targetNode, "width") <= MIN_TARGETNODE_LENGTH) {
     *   return true;
     * }
     */
  }
  return false;
}
/**
 * 根据已经定位的popLayer的定位信息，得到三角的定位位置
 * @param {*} popMessageAlign
 */
function adjustArrowAlign(popMessageAlign, options) {
  // t l r b
  var direction = null; // direction是target相对于arrow的方位
  var offset = [0, 0]; // 定位偏移量
  var points = [];
  var newPoints = popMessageAlign.points;
  // 左右
  if (isLrDirection(newPoints)) {
    if (/^[ctb][r]$/.test(newPoints[0])) {
      points = ['cc', 'cl'];
      // points = ['cr', 'cl'];
      direction = 'r';
    }
    if (/^[ctb][l]$/.test(newPoints[0])) {
      points = ['cc', 'cr'];
      // points = ['cl', 'cr'];
      direction = 'l';
    }
    // direction = points[0].charAt(1);
  }
  // 上下
  if (isTbDirection(newPoints)) {
    if (/^[b][clr]$/.test(newPoints[0])) {
      points = ['cc', 'tc'];
      // points = ['bc', 'tc'];
      direction = 'b';
    }
    if (/^[t][clr]$/.test(newPoints[0])) {
      points = ['cc', 'bc'];
      // points = ['tc', 'bc'];
      direction = 't';
    }
    // direction = points[0].charAt(0);
  }
  // offset: 需调整offset适配临界问题
  offset = adjustArrowReachLimit(options.windowViewport, options.viewport, {
    targetNode: options.targetNode,
    direction: direction
  });
  var arrowAlign = _objectSpread(_objectSpread({}, popMessageAlign), {}, {
    offset: offset,
    points: points
  });
  return [arrowAlign, direction];
}
/**
 * 根据已经定位的popLayer的定位信息，得到三角的定位位置，并定位三角
 * @param {*} popMessageAlign
 */
function arrowDomAlign(popMessageAlign, options) {
  var _adjustArrowAlign = adjustArrowAlign(popMessageAlign, {
      windowViewport: options.windowViewport,
      viewport: options.viewport,
      targetNode: options.targetNode
    }),
    _adjustArrowAlign2 = (0, _slicedToArray2.default)(_adjustArrowAlign, 2),
    arrowAlign = _adjustArrowAlign2[0],
    direction = _adjustArrowAlign2[1];
  (0, _domAlign.default)(options.arrowNode, options.targetNode, arrowAlign);
  return [arrowAlign, direction];
}
var HORIZONTAL_CORNER_DIS = 16; // 边角定位时水平方向上arrow与popNode的距离
var VERTICAL_CORNER_DIS = 8; // 边角定位时垂直方向上arrow与popNode的距离
/**
 * 边角定位时判断target是否小于边角固定的arrow距离，详见https://km.sankuai.com/page/1331698326
 * @param {*} popMessageAlign
 */
function isCornerNeedAlign(popMessageAlign, targetNode) {
  var newPoints = popMessageAlign.points;
  // 左右方位时，判断高度是否太小
  if (isLrDirection(newPoints)) {
    return getWH(targetNode, 'height') < VERTICAL_CORNER_DIS * 2;
  }
  // 上下方位时，判断宽度是否太小
  if (isTbDirection(newPoints)) {
    return getWH(targetNode, 'width') < HORIZONTAL_CORNER_DIS * 2;
  }
  return false;
}